export const AcademicsData = ["2024-25", "2025-26","2026-27"
];
export const ActiveAcademicYear = AcademicsData[2];